module.exports = __webpack_public_path__ + "static/signednapkins-de15fafdb3a5374f7bf84db54bc2a7ac.jpg";